(function () {
  const uploadInput = document.getElementById('logo-upload-input');
  const canvas = document.getElementById('logo-preview-canvas');
  const swatches = document.querySelectorAll('.logo-color-swatch');
  const logoDataHidden = document.getElementById('logo-data-hidden');
  const logoColorHidden = document.getElementById('logo-color-hidden');

  let currentColor = '#1a1a1a';
  let currentImage = null;

  // Selección de color
  swatches.forEach(swatch => {
    swatch.addEventListener('click', function () {
      swatches.forEach(s => s.style.border = '2px solid transparent');
      this.style.border = '2px solid #000';
      currentColor = this.dataset.color;
      logoColorHidden.value = currentColor;
      if (currentImage) applyColor(currentImage, currentColor);
    });
  });

  // Subida de imagen
  uploadInput.addEventListener('change', function (e) {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = function (event) {
      const img = new Image();
      img.onload = function () {
        currentImage = img;
        applyColor(img, currentColor);
      };
      img.src = event.target.result;
    };
    reader.readAsDataURL(file);
  });

  function applyColor(img, color) {
    const ctx = canvas.getContext('2d');
    canvas.width = img.width;
    canvas.height = img.height;
    canvas.style.display = 'block';

    // Dibujar imagen original
    ctx.drawImage(img, 0, 0);

    // Aplicar color usando composite
    ctx.globalCompositeOperation = 'source-in';
    ctx.fillStyle = color;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Resetear composite
    ctx.globalCompositeOperation = 'source-over';

    // Guardar como base64 en el input hidden
    logoDataHidden.value = canvas.toDataURL('image/png');
  }
})();
